module.exports = __webpack_public_path__ + "img/ic_chat_btn_report.c1cde827.svg";